import { getSEODescription } from "@/utils/sanityUtils";

export interface PageDTO {
  _id: string;
  page: string;
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body: any[];
  links?: { title: string; url: string }[];
}

export class PageModel {
  readonly _id: string;
  readonly page: string;
  readonly title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly body: any[];
  readonly links: { title: string; url: string }[] = [];

  constructor(pageDTO: PageDTO) {
    this._id = pageDTO._id;
    this.page = pageDTO.page;
    this.title = pageDTO.title;
    this.body = pageDTO.body;

    if (pageDTO.links && pageDTO.links.length) {
      this.links = pageDTO.links;
    }
  }

  toJSON() {
    return { ...this };
  }

  getSEODescription() {
    return getSEODescription(this.body);
  }
}
